export default {
	server_url: "https://catalogues-backend.rozenbal.fr"
};
